import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode:'history',
  routes: [
    { path: '/mainVenue', name: 'Main', meta: { title: '主会场' }, component: () => import('../view/mainVenue/mainVenue.vue') },
    { path: '/mainVen', name: 'Main', meta: { title: '主会场' }, component: () => import('../view/mainVen/mainVen.vue') },
    // { path: '/receiveRed', name: 'ReceiveRed', meta: { title: '红包' }, component: () => import('../view/receiveRed/receiveRed.vue') },
    // { path: '/receive', name: 'Receive', meta: { title: '红包' }, component: () => import('../view/receive/receive.vue') },
    // { path: '/goLive', name: 'goLive', meta: { title: '七周年活动直播' }, component: () => import('../view/goLive/goLive.vue') },
    // { path: '/redBo', name: 'redBo', meta: { title: '爆品金活动' }, component: () => import('../view/redBo/redBo.vue') },
    { path: '/secondLevel', name: 'secondLevel', meta: { title: '领劵' }, component: () => import('../view/secondLevel/second.vue') },
    { path: '/storage', name: 'storage', meta: { title: '一键入库' }, component: () => import('../view/storage/storage.vue') },
    { path: '/storeSts', name: 'storeSts', meta: { title: '一键入库ss' }, component: () => import('../view/storeSts/index.vue') },
    { path: '/lottery', name: 'lottery', meta: { title: '大转盘' }, component: () => import('../view/lottery/lotteryDraw.vue') },
    // { path: '/sign', name: 'sign', meta: { title: '119签到积分' }, component: () => import('../view/sign/index.vue') },
    // { path: '/provision', name: 'provision', meta: { title: '119厂家特供' }, component: () => import('../view/provision/index.vue') },
    { path: '/exchange', name: 'exchange', meta: { title: '换购' }, component: () => import('../view/exchange/index.vue') },
    { path: '/twoOff', name: 'twoOff', meta: { title: '预热主会场' }, component: () => import('../view/twoOff/index.vue') },
    { path: '/9.2Off', name: '9.2Off', meta: { title: '9.2折' }, component: () => import('../view/9.2Off/index.vue') },
    { path: '/practitioner', name: 'practitioner', meta: { title: '执药医师' }, component: () => import('../view/practitioner/index.vue') },
    { path: '/integral', name: 'integral', meta: { title: '精品积分' }, component: () => import('../view/integral/index.vue') },
    // 爆破日blastingDay
    { path: '/blastingDay', name: 'blastingDay', meta: { title: '爆破日' }, component: () => import('../view/blastingDay/index.vue') },
    //peerList
    { path: '/peerList', name: 'peerList', meta: { title: '随货同行单' }, component: () => import('../view/peerList/index.vue') },
    //superVip  seckill
    { path: '/superVip', name: 'superVip', meta: { title: '超级VIP' }, component: () => import('../view/superVip/index.vue') },
    { path: '/seckill', name: 'seckill', meta: { title: '秒杀预览' }, component: () => import('../view/seckill/index.vue') },
    { path: '/special', name: 'special', meta: { title: '特殊商品' }, component: () => import('../view/special/index.vue') },
    { path: '/blastingDays', name: 'blastingDays', meta: { title: '特殊商品' }, component: () => import('../view/blastingDays/index.vue') },
    // giveAneNcore
    { path: '/giveAneNcore', name: 'giveAneNcore', meta: { title: '返场狂欢' }, component: () => import('../view/giveAneNcore/index.vue') },
    { path: '/join', name: 'join', meta: { title: '加盟' }, component: () => import('../view/join/index.vue') },
    { path: '/memberDay', name: 'memberDay', meta: { title: '加盟' }, component: () => import('../view/memberDay/index.vue') },
    { path: '/industry', name: 'industry', meta: { title: '新工业积分兑换' }, component: () => import('../view/industry/index.vue') },
    //爆品购物金
    { path: '/hotShopGold', name: 'hotShopGold', meta: { title: '爆品购物金' }, component: () => import('../view/2023/hotShopGold.vue') },
    //8月营销策略
    { path: '/augustMarket', name: 'augustMarket', meta: { title: '8月营销策略' }, component: () => import('../view/2023/augustMarket.vue') },
    //9月营销策略
    { path: '/sepStrategy', name: 'SepStrategy', meta: { title: '9月营销策略' }, component: () => import('../view/2023/sepStrategy.vue') },
    //10月营销策略
    { path: '/pcOctoberStrategy', name: 'PcOctoberStrategy', meta: { title: '10月营销策略' }, component: () => import('../view/2023/octoberStrategy.vue') },
    // 马氏针灸
    { path: '/acupunctureAd', name: 'AcupunctureAd', meta: { title: '马氏温灸' }, component: () => import('../view/2023/acupunctureAd.vue') },
    //12月营销策略
    { path: '/pcDecemberStrategy', name: 'PcDecemberStrategy', meta: { title: '12月营销策略' }, component: () => import('../view/2023/decemberStrategy.vue') },
    //12月会员日
    { path: '/pcVipDay', name: 'VipDay', meta: { title: '12月会员日' }, component: () => import('../view/2023/vipDay.vue') },
    //24年1月店铺营销
    { path: '/pcStoreMarket', name: 'StoreMarket', meta: { title: '1月店铺营销' }, component: () => import('../view/2023/storeMarket.vue') },
    //24年1月重庆区域
    { path: '/pcCqArea', name: 'cqArea', meta: { title: '1月重庆区域' }, component: () => import('../view/2023/cqArea.vue') },
    //课程试听
    { path: '/pcCourse', name: 'course', meta: { title: '课程试听' }, component: () => import('../view/2024/course.vue') },
    //健康之家
    { path: '/pcHealthHome', name: 'healthHome', meta: { title: '健康之家' }, component: () => import('../view/2024/healthHome.vue') },
    //1月18会员日
    { path: '/pcJanuaryVipDay', name: 'januaryVipDay', meta: { title: '1月会员日' }, component: () => import('../view/2024/januaryVipDay.vue') },
    //2月3省钱指南
    { path: '/pcEconomizeMoney', name: 'economizeMoney', meta: { title: '省钱指南' }, component: () => import('../view/2024/economizeMoney.vue') },
    //门店营销
    { path: '/pcMarket', name: 'market', meta: { title: '门店营销' }, component: () => import('../view/2024/market.vue') },
    //贵必赔
    { path: '/cheap', name: 'cheap', meta: { title: '贵必赔' }, component: () => import('../view/2024/cheap.vue') },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js